import cn from "clsx"
import styled from "styled-components"

const PaginationButton = styled.button<{ active?: boolean; disableHover?: boolean }>`
  width: 50px;
  height: 50px;
  outline: none;
  color: ${(props) => props.theme.palette.primary_dark};
  border: none;
  background: transparent;
  border-radius: 16px;
  font-size: 100%;
  font-family: "Inter";

  &:hover {
    background-color: ${(props) => props.theme.palette.secondary_gray_light};
    width: 50px;
    height: 50px;
    color: ${(props) => props.theme.palette.primary_dark};
    border-radius: 16px;
  }

  &.active {
    background: ${(props) => props.theme.palette.gray_light};
  }

  &.disableHover {
    &:hover {
      background: ${(props) => props.theme.palette.white};
      color: ${(props) => props.theme.palette.black};
    }
  }
`

interface PageButtonProps {
  page: number | string
  pageIndex?: number
  onChange: (page: number | string | undefined) => void
}

export const PageButton = ({ page, pageIndex, onChange }: PageButtonProps) => (
  <PaginationButton
    onClick={() => onChange(page)}
    className={cn({
      active: pageIndex === page,
      disableHover: typeof page === "string"
    })}
  >
    {" "}
    {page}{" "}
  </PaginationButton>
)
